import { usersOrganisationsRolesQueryOptions } from "@/features/auth/api/selectUsersOrganisationsRoles";
import { getOnboardedAppHome } from "@/features/auth/utils/getAuthenticatedPublicLanding";
import { canOpenBuilder } from "@/features/builder/utils/builderAccess";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/builder")({
    component: () => <Outlet />,
    beforeLoad: async ({ context, location }) => {
        const userId = context?.auth?.id;
        if (!userId || !context?.queryClient) {
            throw redirect({ to: "/login" });
        }

        // Roles are loaded in `/_app` loader, which runs after child beforeLoads.
        // Resolve them here so a hard navigation to /builder/* does not treat admins as guests.
        const roles = await context.queryClient.ensureQueryData(usersOrganisationsRolesQueryOptions(userId));
        context.auth.roles.setRoles(roles ?? []);

        if (
            !canOpenBuilder({
                isAdmin: context.auth.roles.isAdmin,
                isClinician: context.auth.roles.isClinician,
                pathname: location.pathname,
            })
        ) {
            throw redirect({
                to: getOnboardedAppHome(context.auth.roles),
            });
        }

        return context;
    },
});
